import { createAction, props } from '@ngrx/store';
import { EventSwitcherView } from '../../modules/main/enums/eventSwitcherView.enum';

export const SET_ACTIVE_EVENT_SWITCHER_VIEW = '[EVENT_SWITCHER] SET_ACTIVE_EVENT_SWITCHER_VIEW';

export const setActiveEventSwitcherViewAction = createAction(
  SET_ACTIVE_EVENT_SWITCHER_VIEW,
  props<{ payload: { eventSwitcherView: EventSwitcherView } }>()
);
